import {
  ChangeDetectorRef,
  Component,
  effect,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterLinkActive,
} from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";

import { CommonModule, DOCUMENT } from "@angular/common";
import {
  NgbModal,
  NgbNav,
  NgbNavModule,
  NgbPopover,
  NgbTooltip,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import { DisplayDescriptionComponent } from "src/app/shared/components/display-description/display-description.component";
import { COOKIE_PREFIX } from "src/environments/environment";
import {
  API_URLS,
  FILE_PATH_PLAN,
  SCROLLBARS_OPTIONS,
  SELECT_SEX,
  SLIDER_CONFIGURATION,
} from "../../../config/app.constants";
import { Globals } from "../../../globals";
import { OutPostModalService } from "../../../shared/header/outpost-list-modal/out-post-modal.service";
import { OutpostListModalComponent } from "../../../shared/header/outpost-list-modal/outpost-list-modal.component";
import { CartsService } from "../../../shared/services/carts.service";
import { HttpinterceptorService } from "../../../shared/services/httpinterceptor.service";
import { Utils } from "../../../shared/utils";
import { StarRatingComponent } from "../star-rating/star-rating.component";

declare var $: any;

@Component({
  selector: "app-plans",
  templateUrl: "./plans.component.html",
  styleUrls: ["./plans.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    SlickCarouselModule,
    StarRatingComponent,
    RouterLink,
    RouterLinkActive,
    NgbTooltip,
    NgbPopover,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxTrimDirectiveModule,
    OutpostListModalComponent,
    NgbNavModule,
    NgbTooltipModule,
  ],
  providers: [NgbNav],
})
export class PlansComponent implements OnInit, OnDestroy {
  active: string = "tab1";
  isRightMarkForFirst: boolean = false;
  isRightMarkForSecond: boolean = false;

  selectedOutpost: any = "";
  selectedOutpostId;
  private subscription: Subscription;
  currentPlanId: string;
  editCartId: string;
  filePath: string = FILE_PATH_PLAN;
  planDetails;
  sliderImages: any[];
  plans;
  PlanPrice: any = 0;
  servicePrice: any = 0;
  totalPrice = 0;
  selectedPlanId: string = "";
  extraServices = [];
  selectedServices = [];
  displayPopup = false;
  select_sex = SELECT_SEX;
  submitted: boolean = false;
  cartDetails;
  cartDetailsToSend = {
    plan_level_id: "",
    extra_services: "any",
    pet_info: {},
    guest_id: "",
    item_type: "",
    is_renewable: false,
  };
  popupValue = {
    title: "",
    description: "",
  };
  planActionType = this.route.snapshot.data.type;
  planEditMode: boolean = false;
  formCheckoutPage: boolean = false;
  pageRedirectType: string = "";
  showOutpostModal: boolean = false;

  petDetails = new FormGroup({
    name: new FormControl(""),
    age: new FormControl(""),
    color: new FormControl(""),
    sex: new FormControl(""),
    weight: new FormControl(""),
    breed: new FormControl(""),
    microchip: new FormControl(""),
    pet_type_id: new FormControl(""),
    description: new FormControl(""),
    pet_id: new FormControl(null),
  });

  topBannerSlideConfig = SLIDER_CONFIGURATION.PLAN;

  scrollbarOptions = SCROLLBARS_OPTIONS;

  userPets = [];
  appliedSubscriptionPets = [];
  checkUserAuthentication = localStorage.getItem(`${COOKIE_PREFIX}_token`);
  isAuthenticatedUser: boolean = false;
  subscriptionPlanFilter: any = null;
  petHasActiveSubscription: boolean = false;
  alreadyAdded: boolean = false;
  currentPlan;
  isOpenOutpostModal: boolean = false;
  apiParams = {};
  selectedPlanData: any = "";
  extraServicesInPlan = [];
  petTypeId: any;
  selectedPetInformation: any;

  constructor(
    private http: HttpinterceptorService,
    private route: ActivatedRoute,
    private router: Router,
    private toasterService: ToastrService,
    private cartsService: CartsService,
    private globals: Globals,
    private cdr: ChangeDetectorRef,
    private outpostModalService: OutPostModalService,
    private modalService: NgbModal,
    @Inject(DOCUMENT) private document: Document
  ) {
    effect(() => {
      const el: any = this.outpostModalService.activatedPlan();

      if (el) {
        this.selectedPlanId = "";
        this.showOutpostModal = false;

        if (localStorage.getItem("selectedOutpostId")) {
          this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
        }
        this.valueSetUp();
        this.active = "tab1";
        this.updateTabCompletionStatus(1);
      }
    });

    if (this.planActionType === "edit") {
      this.planEditMode = true;
    }
    this.cartDetails = JSON.parse(this.cartsService.getCartItems());
    Utils.enableBodyScroll();
    this.document.body.classList.remove("body-overflow");

    this.changeAppliedSubscriptionPets();
    if (this.checkUserAuthentication) {
      if (
        (globals.currentUser ||
          (globals.currentUser && globals.currentUser.switch)) &&
        globals.currentUser.type != "backend"
      ) {
        this.isAuthenticatedUser = true;
      }
    }

    this.route.params.subscribe((params) => {
      this.petTypeId = params["slug"];
    });
  }
  @HostListener("keyup.enter")
  onEnter() {
    this.cdr.detectChanges();
  }

  ngOnInit() {
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }

    // this.currentPlan = this.outpostModalService.currentPlan.subscribe(
    //   (el: any) => {
    //     if (el) {
    //       this.selectedPlanId = "";
    //       this.showOutpostModal = false;

    //       if (localStorage.getItem("selectedOutpostId")) {
    //         this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    //       }
    //       this.valueSetUp();
    //       this.active = "tab1";
    //       this.updateTabCompletionStatus(1);
    //     }
    //   }
    // );

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.subscription = this.cartsService.cartItems.subscribe((cartItems) => {
      this.cartDetails = JSON.parse(cartItems);
      this.changeAppliedSubscriptionPets();
    });
    if (!this.planEditMode && sessionStorage.subscriptionPlanFilter) {
      this.subscriptionPlanFilter = JSON.parse(
        sessionStorage.subscriptionPlanFilter
      );
      if (this.subscriptionPlanFilter) {
        sessionStorage.removeItem("subscriptionPlanFilter");
      }
      this.getPets(this.subscriptionPlanFilter.petTypeId);
    } else {
      this.petSelectionChange();
    }
    this.valueSetUp();
  }

  ngOnDestroy() {
    if (this.currentPlan) {
      this.currentPlan.unsubscribe();
    }
    if (this.planEditMode) {
      this.subscription.unsubscribe();
    }
  }

  changeAppliedSubscriptionPets() {
    this.appliedSubscriptionPets = [];
    if (this.cartDetails && this.cartDetails["items"]) {
      this.cartDetails["items"].forEach((element) => {
        if (element.item_type == "subscription") {
          this.appliedSubscriptionPets.push(element.pet_id);
        }
      });
    }
  }

  valueSetUp() {
    this.route.params.subscribe((params) => {
      this.pageRedirectType = params["pageType"];
      if (
        this.pageRedirectType === "edit" ||
        this.pageRedirectType === "checkout_edit" ||
        !this.planEditMode
      ) {
        if (this.pageRedirectType === "checkout_edit") {
          this.formCheckoutPage = true;
        }
        this.currentPlanId = params["id"];

        const requestParams = {
          plan_id: this.currentPlanId,
          out_post_id: this.selectedOutpostId,
          pet_type_slug: this.petTypeId,
        };

        if (this.planEditMode) {
          this.editCartId = params["cartId"];
        }

        if (this.cartDetails && this.cartDetails["items"]) {
          for (const index in this.cartDetails["items"]) {
            if (
              Object.prototype.hasOwnProperty.call(
                this.cartDetails["items"],
                index
              )
            ) {
              if (
                this.editCartId ==
                this.cartDetails["items"][index].cart_unique_id
              ) {
                this.selectedPetInformation =
                  this.cartDetails["items"][index].pet_info;
                requestParams["pet_type_id"] =
                  this.selectedPetInformation.pet_type_id;
              }
            }
          }
        }

        this.http.post(API_URLS.GET_PLAN, requestParams, false).subscribe(
          (res) => {
            this.PlanPrice = 0;
            this.servicePrice = 0;
            this.totalPrice = 0;
            if (res.code == 200 && res.type === "success") {
              if (res.data) {
                this.planDetails = res.data;
                this.planDetails["HTMLDescription"] = res.data.description;
                this.planDetails["description"] = Utils.htmlToPlaintext(
                  res.data.description
                );
                if (this.isAuthenticatedUser && !this.subscriptionPlanFilter) {
                  if (!this.planEditMode) {
                    this.getPets(
                      this.petTypeId
                        ? this.petTypeId
                        : this.planDetails.pet_type_id
                    );
                  }
                }
                this.sliderImages = res.data.slider_images.split(",");
                this.plans = res.data.plan_levels_with_services;
                if (!this.planDetails.is_available_for_outpost) {
                  for (const plan in this.plans) {
                    if (
                      Object.prototype.hasOwnProperty.call(this.plans, plan)
                    ) {
                      this.plans[plan].is_available_for_outpost = 0;
                    }
                  }
                } else {
                  for (const plan in this.plans) {
                    if (
                      Object.prototype.hasOwnProperty.call(this.plans, plan)
                    ) {
                      this.plans[plan].is_available_for_outpost = 1;
                    }
                  }
                }
                this.convertPriceToDollerAndCentForHtmlDisplay();
                this.calculateDiscount();
                this.bindingNewKeyForAddonDescription(res.data.extraServices);
                if (this.planEditMode) {
                  this.getSelectedData();
                } else {
                  if (
                    this.subscriptionPlanFilter &&
                    this.subscriptionPlanFilter.planLevelId
                  ) {
                    const planData = this.plans.filter(
                      (data) =>
                        data.id == this.subscriptionPlanFilter.planLevelId
                    );
                    this.selectPlan(planData.length ? planData[0] : false);
                  }
                }
              }
            }
          },
          (error) => {
            this.router.navigate(["/"]);
          }
        );
      } else {
        this.router.navigate(["/"]);
      }
    });
  }

  getSelectedData() {
    const services = [];
    for (const index in this.cartDetails["items"]) {
      if (
        Object.prototype.hasOwnProperty.call(this.cartDetails["items"], index)
      ) {
        if (
          this.editCartId == this.cartDetails["items"][index].cart_unique_id
        ) {
          this.selectedPlanId = this.cartDetails["items"][index].plan_level_id;
          // const resPetInfo = JSON.parse(this.cartDetails['items'][index].pet_info);
          this.selectedPetInformation =
            this.cartDetails["items"][index].pet_info;
          this.petDetails.patchValue(this.selectedPetInformation);
          if (this.selectedPetInformation.pet_id) {
            this.setNewPetValidation(false);
          }
          this.PlanPrice =
            this.cartDetails["items"][index].plan_level.monthly_price;
          if (this.cartDetails["items"][index].extra_services.length > 0) {
            for (const key in this.cartDetails["items"][index].extra_services) {
              if (
                Object.prototype.hasOwnProperty.call(
                  this.cartDetails["items"][index].extra_services,
                  key
                )
              ) {
                this.servicePrice +=
                  this.cartDetails["items"][index].extra_services[
                    key
                  ].monthly_price;
                services.push(
                  this.cartDetails["items"][index].extra_services[key].id
                );
              }
            }
          }
          this.totalPrice = (this.PlanPrice + this.servicePrice).toFixed(2);
        }
      }
    }
    this.getPets(this.selectedPetInformation.pet_type_id);

    this.selectedServices = services;
  }

  savePetDetails() {
    this.submitted = true;
    if (this.alreadyAdded) {
      this.toastMessage(
        "error",
        "Subscription is already added to cart for this pet"
      );
    } else {
      let petDetailsForm = <FormGroup>this.petDetails;
      if (petDetailsForm.valid) {
        this.petDetails.value.pet_type_id = this.planDetails.pet_type_id;
        this.cartDetailsToSend.plan_level_id = this.selectedPlanId;
        this.cartDetailsToSend.guest_id = sessionStorage.getItem("guest_id");
        this.cartDetailsToSend.item_type = "subscription";
        if (this.selectedServices.length > 0) {
          this.cartDetailsToSend.extra_services =
            this.selectedServices.toString();
        } else {
          this.cartDetailsToSend.extra_services = "";
        }
        this.cartDetailsToSend.pet_info = this.petDetails.value;
        this.cartDetailsToSend.pet_info["pet_type_id"] = this.planEditMode
          ? this.selectedPetInformation.pet_type_id
          : this.planDetails.pet_type_id;
        this.cartDetailsToSend.pet_info["pet_type_slug"] = this.planEditMode
          ? this.selectedPetInformation.pet_type_slug
          : this.petTypeId;

        if (this.planEditMode) {
          this.cartDetailsToSend["cart_id"] = this.editCartId;
        }
        this.cartDetailsToSend["pet_id"] = this.petDetails.value.pet_id;
        this.cartDetailsToSend["out_post_id"] = this.selectedOutpostId;

        this.http
          .post(API_URLS.UPDATE_CART, this.cartDetailsToSend, true)
          .subscribe(
            (res) => {
              if (res.code == "200" && res.type === "success") {
                if (res.data) {
                  this.submitted = false;
                  this.petDetails.reset();
                  this.selectedPlanId = "";
                  this.selectedServices = [];
                  this.totalPrice = 0;
                  this.PlanPrice = 0;
                  this.servicePrice = 0;
                  this.priceCalculation();
                  sessionStorage.setItem("guest_id", res.data.guest_id);
                  this.cartsService.getCartWithApi();
                  if (this.formCheckoutPage && this.planEditMode) {
                    this.router.navigate(["checkout"]);
                  } else {
                    let url;
                    if (
                      this.selectedPetInformation &&
                      this.selectedPetInformation.pet_type_slug
                    ) {
                      url = `/plans/${this.currentPlanId}/${this.selectedPetInformation.pet_type_slug}`;
                    } else if (this.petTypeId) {
                      url = `/plans/${this.currentPlanId}/${this.petTypeId}`;
                    } else {
                      url = `/plans/${this.currentPlanId}`;
                    }
                    this.router.navigate([url]);
                    window.scroll(0, 0);
                  }
                  this.active = "tab1";
                  this.updateTabCompletionStatus(1);
                }
              }
            },
            (error) => {
              this.submitted = false;
              return false;
            }
          );
      } else {
        return false;
      }
    }
  }

  toastMessage(type, message) {
    this.toasterService[type](message);
  }

  convertPriceToDollerAndCentForHtmlDisplay() {
    for (const key in this.plans) {
      if (this.plans.hasOwnProperty(key)) {
        let price;
        if (this.plans[key].monthly_price % 1 !== 0) {
          price = this.plans[key].monthly_price.toString().split(".");

          if (price[1].length === 1) {
            price[1] = price[1] + "0";
          }
          this.plans[key]["doller"] = price[0];
          this.plans[key]["cent"] = price[1].slice(0, 2);
        } else {
          this.plans[key]["doller"] = this.plans[key].monthly_price;
          this.plans[key]["cent"] = "00";
        }
      }
    }
  }

  calculateDiscount() {
    for (const key in this.plans) {
      if (this.plans.hasOwnProperty(key)) {
        let discountedPrice = 0;
        let calculatePrice = 0;
        calculatePrice = this.plans[key].price / this.plans[key].months;
        this.plans[key].actual_price = calculatePrice;
        discountedPrice =
          100 - (this.plans[key].monthly_price * 100) / calculatePrice;
        if (Math.round(discountedPrice) > 0) {
          this.plans[key].discounted = Math.round(discountedPrice);
          this.plans[key]["isDiscount"] = true;
        } else {
          this.plans[key].discounted = 0;
          this.plans[key]["isDiscount"] = false;
        }
      }
    }
  }

  bindingNewKeyForAddonDescription(extraServices) {
    this.extraServices = [];
    this.selectedServices = [];
    for (const key in extraServices) {
      if (extraServices.hasOwnProperty(key)) {
        const extraService = extraServices[key];
        if (this.planDetails.is_available_for_outpost) {
          this.extraServices.push({
            description: extraService.description,
            id: extraService.id,
            created_by: extraService.created_by,
            created_at: extraService.created_at,
            is_active: extraService.is_active,
            plan_id: extraService.plan_id,
            price: extraService.price,
            title: extraService.title,
            short_description: Utils.htmlToPlaintext(extraService.description),
            is_available_for_outpost: 1,
            monthly_price: extraService.monthly_price,
          });
        } else {
          this.extraServices.push({
            description: extraService.description,
            id: extraService.id,
            created_by: extraService.created_by,
            created_at: extraService.created_at,
            is_active: extraService.is_active,
            plan_id: extraService.plan_id,
            price: extraService.price,
            title: extraService.title,
            short_description: Utils.htmlToPlaintext(extraService.description),
            is_available_for_outpost: 0,
            monthly_price: extraService.monthly_price,
          });
        }
      }
    }
  }

  selectServices(service) {
    if (this.selectedServices.indexOf(service.id) == -1) {
      this.selectedServices.push(service.id);
      this.servicePrice = parseFloat(this.servicePrice + service.monthly_price);
      this.priceCalculation();
    } else {
      for (const key in this.selectedServices) {
        if (this.selectedServices.hasOwnProperty(key)) {
          if (this.selectedServices[key] == service.id) {
            this.selectedServices.splice(parseInt(key), 1);
            this.servicePrice =
              parseFloat(this.servicePrice) - parseFloat(service.monthly_price);
            this.priceCalculation();
          }
        }
      }
    }
  }

  selectPlan(plan) {
    this.selectedServices = [];
    this.servicePrice = 0;
    this.selectedPlanId = plan.id;
    this.selectedPlanData = plan;
    this.PlanPrice = parseFloat(plan.monthly_price);
    this.priceCalculation();
    this.disabledExtraServices();
    this.goToNext();
  }

  priceCalculation() {
    this.totalPrice =
      parseFloat(this.PlanPrice) + parseFloat(this.servicePrice);
  }

  // open popup and show description of plan and plan level

  showDescription(title, description) {
    this.apiParams = {
      title: title,
      description: description,
    };
    const modalRef = this.modalService.open(DisplayDescriptionComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.fromParent = { data: this.apiParams };
  }

  getPets(petTypeId) {
    if (petTypeId && this.isAuthenticatedUser) {
      this.http
        .post(
          API_URLS.GET_USER_PETS,
          { pet_type_id: petTypeId, out_post_id: this.selectedOutpostId },
          false
        )
        .subscribe((response) => {
          if (
            response.type === "success" &&
            response.code == "200" &&
            response.data
          ) {
            this.userPets = response.data.filter((pet) => pet?.is_active);
            if (
              this.subscriptionPlanFilter &&
              this.subscriptionPlanFilter.petID &&
              !this.planEditMode
            ) {
              const petData = this.userPets.filter(
                (data) => data.id == this.subscriptionPlanFilter.petID
              );
              this.petSelectionChange(petData.length ? petData[0] : false);
            }
          }
        });
    }
  }

  petSelectionChange(event?) {
    this.submitted = false;
    this.petHasActiveSubscription = false;
    this.alreadyAdded = false;
    if (event) {
      if (
        event.has_active_subscription ||
        this.appliedSubscriptionPets.includes(event.id)
      ) {
        const petIdControl = <FormControl>this.petDetails.controls["pet_id"];
        petIdControl.setValue(null);
        if (event.has_active_subscription) {
          this.petHasActiveSubscription = true;
          this.toastMessage("error", "Already has active subscription");
        } else {
          this.alreadyAdded = true;
          this.toastMessage(
            "error",
            "Subscription is already added to cart for this pet"
          );
        }
        this.setNewPetData();
      } else {
        const prepareData = {
          name: event.name ? event.name : "",
          sex: event.sex ? event.sex : "",
          color: event.color ? event.color : "",
          age: event.age ? event.age : "",
          weight: event.weight ? event.weight : "",
          breed: event.breed_name ? event.breed_name : "",
          microchip: event.microchip ? event.microchip : "",
          pet_type_id: event.pet_type_id ? event.pet_type_id : "",
          description: event.description ? event.description : "",
          pet_id: event.id ? event.id : null,
        };
        this.petDetails.patchValue(JSON.parse(JSON.stringify(prepareData)));
        this.setNewPetValidation(false);
      }
    } else {
      this.setNewPetData();
    }
  }

  setNewPetData() {
    this.alreadyAdded = false;
    this.setNewPetValidation(true);
    this.petDetails.reset();
    const sexControl = <FormControl>this.petDetails.controls["sex"];
    sexControl.setValue("male");
  }

  setNewPetValidation(flag) {
    const petDetailsForm = <FormGroup>this.petDetails;
    const nameControl = <FormControl>petDetailsForm.controls["name"];
    const sexControl = <FormControl>petDetailsForm.controls["sex"];
    const colorControl = <FormControl>petDetailsForm.controls["color"];
    const ageControl = <FormControl>petDetailsForm.controls["age"];
    const weightControl = <FormControl>petDetailsForm.controls["weight"];
    const breedControl = <FormControl>petDetailsForm.controls["breed"];
    const petIdControl = <FormControl>petDetailsForm.controls["pet_id"];
    if (flag) {
      nameControl.setValidators([Validators.required]);
      sexControl.setValidators([Validators.required]);
      colorControl.setValidators([Validators.required]);
      ageControl.setValidators([
        Validators.required,
        Validators.pattern(/^\d+(\.\d)?$/),
      ]);
      weightControl.setValidators([
        Validators.required,
        Validators.pattern("^[0-9]+(.?[0-9]+)*$"),
      ]);
      breedControl.setValidators([Validators.required]);
      petIdControl.clearValidators();
    } else {
      nameControl.clearValidators();
      sexControl.clearValidators();
      colorControl.clearValidators();
      ageControl.clearValidators();
      weightControl.clearValidators();
      breedControl.clearValidators();
      petIdControl.setValidators([Validators.required]);
    }
    nameControl.updateValueAndValidity();
    sexControl.updateValueAndValidity();
    colorControl.updateValueAndValidity();
    ageControl.updateValueAndValidity();
    weightControl.updateValueAndValidity();
    breedControl.updateValueAndValidity();
    petIdControl.updateValueAndValidity();
  }

  onSelect() {
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }
    this.apiParams = {
      service_id: this.planDetails.id,
      service_type: "subcription",
    };

    const modalRef = this.modalService.open(OutpostListModalComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.fromParent = { data: this.apiParams };
    modalRef.componentInstance.closeOutpostModal.subscribe(
      (response) => {
        if (response) {
          this.selectedOutpost = response.title;
          this.selectedOutpostId = response.id;
          this.valueSetUp();
          this.storeOutpostIdInLocalStorage();
        }
        window.scrollTo(0, 0);
      },
      (reason) => {}
    );
  }
  storeOutpostIdInLocalStorage() {
    if (localStorage.getItem("selectedOutpostId")) {
      localStorage.removeItem("selectedOutpostId");
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    } else {
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    }
  }
  disabledExtraServices() {
    const extraServiceFromPlan = this.planDetails.extraServices.map(
      (extraService) => extraService.id
    );
    const sortServices = this.selectedPlanData.sortServices.map(
      (service) => service.id
    );

    this.extraServicesInPlan = extraServiceFromPlan.filter((extraService) =>
      sortServices.some((sortService) => extraService === sortService)
    );
  }

  goToNext() {
    if (!this.selectedPlanId) {
      this.toastMessage("error", "Please select a plan");
      return;
    }

    // Get the index of the active tab
    const currentIndex = this.getCurrentIndex(this.active, ""); // Extract the number from the active tab ID

    // If there's a next tab, select it
    if (currentIndex < 3) {
      const nextTabId = `tab${currentIndex + 1}`;
      this.active = nextTabId;

      // Change the color of the previous tab
      const previousTabId = `tab${currentIndex}`;

      const previousTabElement = document.getElementById(previousTabId);
      if (previousTabElement) {
        previousTabElement.querySelector("button").classList.add("completed"); // Change to desired color
      }

      const buttonElement = previousTabElement.querySelector("button");
      if (buttonElement) {
        // Check if the completed class is present
        const isCompleted = buttonElement.classList.contains("completed");
        // Set flag or mark as right based on the completed status
        if (isCompleted) {
          // Set flag or mark as right here
          if (previousTabId == "tab1") {
            this.isRightMarkForFirst = true;
          } else {
            this.isRightMarkForSecond = true;
          }
        }
      }
    }
    this.scrollToTop();
  }
  goToPrev() {
    // Get the index of the active tab
    const currentIndex = this.getCurrentIndex(this.active, ""); // Extract the number from the active tab ID

    // If there's a previous tab, select it
    if (currentIndex > 1) {
      const previousTabId = `tab${currentIndex - 1}`;
      this.active = previousTabId;

      // Remove the completed class from the current tab button
      const currentTabId = `tab${currentIndex}`;

      const currentTabElement = document.getElementById(currentTabId);
      const prevTabElement = document.getElementById(previousTabId);

      const buttonElement = prevTabElement.querySelector("button");
      if (buttonElement) {
        // Check if the completed class is present
        const isCompleted = buttonElement.classList.contains("completed");
        // Set flag or mark as right based on the completed status
        if (isCompleted) {
          // Set flag or mark as right here
          if (previousTabId == "tab1") {
            this.isRightMarkForFirst = false;
          } else {
            this.isRightMarkForSecond = false;
          }
        }
      }

      if (currentTabElement) {
        currentTabElement.querySelector("button").classList.remove("completed");
      }
    }
    this.scrollToTop();
  }
  changeTab(event) {
    // Get the index of the newly selected tab
    const activeTabIndex = this.getCurrentIndex("", event);
    // Update the completed status of tabs
    this.updateTabCompletionStatus(activeTabIndex);
  }
  // Define a method to update the completed status of tabs
  updateTabCompletionStatus(activeTabIndex: number) {
    for (let i = 1; i <= 3; i++) {
      const tabId = `tab${i}`;
      const tabElement = document.getElementById(tabId);
      if (tabElement) {
        const buttonElement = tabElement.querySelector("button");
        if (buttonElement) {
          if (i < activeTabIndex) {
            buttonElement.classList.add("completed");
          } else {
            buttonElement.classList.remove("completed");
          }
        }
      }

      if (activeTabIndex == 1) {
        this.isRightMarkForFirst = false;
        this.isRightMarkForSecond = false;
      } else if (activeTabIndex == 2) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = false;
      } else if (activeTabIndex == 3) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = true;
      }
    }
  }

  getCurrentIndex(activeTab?, event?) {
    if (event) {
      return parseInt(event.nextId.substr(3));
    } else if (activeTab) {
      return parseInt(this.active.substring(3));
    }
  }

  scrollToTop() {
    window.scroll(490, 490);
  }
}
